import { cairo, CallData } from 'starknet';
export function buildRefundTx(params) {
    return {
        contractAddress: params.contractAddress,
        entrypoint: 'refund_user',
        calldata: CallData.compile([cairo.uint256(BigInt(params.id))]),
    };
}
